import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spinner",
  "use": "spinner-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"spinner\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"7\" cy=\"7\" r=\"6\" stroke=\"#000\" stroke-opacity=\".1\" stroke-width=\"2\" /><path fill=\"#000\" fill-opacity=\".1\" fill-rule=\"nonzero\" d=\"M7 0a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5V0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol